import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, FormSpy } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { translate } from 'react-polyglot';

import WrappedFormSelect from './WrappedFormSelect';
import FormInput from './FormInput';
import { ArrowDown } from '../icons';

import 'react-select/dist/react-select.css';
import './FormSelect.css';
import FormInputHolder from './FormInputHolder';
import FormLabel from './FormLabel';
import { required } from '../../helpers/formValidators';
import { Error } from './BaseForm';

const FormSelect = (props) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const newOptions = [...props.options];

    if (props.includeOther) {
      newOptions.push({
        'label': `${props.t('profile.profileOtherFillInBelow')}`,
        'value': 'other'
      });
    }

    setOptions(newOptions);
  }, [props.options, props.includeOther]);

  return (
    <React.Fragment>
      <div className="form-select">
        <Field
          arrowRenderer={() => (
            <ArrowDown
              className="form-select__expand"
              width="2.4rem"
              height="2.4rem"
            />
          )}
          // placeholder={props.placeholder}
          name={props.name}
          component={WrappedFormSelect}
          options={options || []}
          disabled={props.disabled}
          tabIndex={props.disabled ? '-1' : undefined}
          validate={props.validate}
          onChange={props.onChange}
          value={props.value}
          initialValue={props.initialValue}
        />

        <Field name={props.otherName} subscription={{}}>
          {(
            { input }
          ) => (
            // if the select value isn't other, wipe the 'other' field
            <OnChange name={props.name}>
              {value => {
                if (!!input.name && value !== 'other') {
                  input.onChange(null);
                }
              }}
            </OnChange>
          )}
        </Field>

        <FormSpy
          subscription={{ values: true }}
        >
          {({ values }) => (
            props.includeOther && (values[props.name] === 'other') ? (
              <FormInputHolder>
                <FormInput
                  id="formSelect.other"
                  name={props.otherName}
                  type="text"
                  value={values[props.otherName]}
                  validate={required}
                  maxLength={100}
                  labelRenderer={() => <FormLabel>{props.otherLabel ? props.otherLabel : 'Other'}</FormLabel>}
                />
              </FormInputHolder>
            ) : (
              null
            )
          )}
        </FormSpy>
      </div>

      <Error name={props.name} />
    </React.Fragment>
  );
}

FormSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string
    })
  ).isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool
};

FormSelect.defaultProps = {
  placeholder: 'Select...',
  disabled: false,
  required: false
};

export default translate()(FormSelect);



// WEBPACK FOOTER //
// ./src/components/form/FormSelect.js